import { Action, createReducer, on } from '@ngrx/store';
import { SnippetProfileListType } from '../../enums/profile-list-type.enum';
import { ConfigData, DistributionProfile, SnippetProfileList } from '../../interfaces/config-data.interface';
import { DocumentSaveInitData } from '../../interfaces/document-init-data.interface';
import { IPermissionOptions } from '../../interfaces/permission-options.interface';
import * as configActions from '../actions/config.actions';

export const userFeatureKey = 'user';

export interface State {
    configs: ConfigData<any>[];
    permissionOptions: IPermissionOptions;
    profileLists: {
        [SnippetProfileListType.DistributionList]: SnippetProfileList<DistributionProfile[][]>[];
    };
    savedInitData: {
        [docFavId: string]: {
            list: ConfigData<DocumentSaveInitData>[];
            active?: ConfigData<DocumentSaveInitData>;
        };
    };
}

export const initialState: State = {
    configs: [],
    permissionOptions: null,
    profileLists: {
        [SnippetProfileListType.DistributionList]: []
    },
    savedInitData: {}
};

const configReducer = createReducer(
    initialState,
    on(configActions.updateLocalConfigs, (state, { list }) => ({
        ...state,
        configs: list
    })),
    on(configActions.getPermissionOptionsSuccess, (state, { list }) => ({
        ...state,
        permissionOptions: list
    })),
    on(configActions.getProfileListSuccess, (state, { listType, data }) => ({
        ...state,
        profileLists: {
            ...state.profileLists,
            [listType]: data
        }
    })),
    on(configActions.getSavedInitDataListForDocumentSuccess, (state, { docFavId, initDataList }) => ({
        ...state,
        savedInitData: {
            ...state.savedInitData,
            [docFavId]: {
                list: initDataList
            }
        }
    })),
    on(configActions.setActiveInitDataForDocument, (state, { initData }) => ({
        ...state,
        savedInitData: {
            ...state.savedInitData,
            [initData.entityId.split('#')[1]]: {
                ...state.savedInitData[initData.entityId.split('#')[1]],
                active: initData
            }
        }
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return configReducer(state, action);
}
